import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device_compose",
  "use": "device_compose-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device_compose\"><path d=\"M4 4h2v1.5H4V4zM7 4h3v1.5H7V4zM8 11.25v-1.5H6v1.5h2zM12 9.75H9v1.5h3v-1.5z\" /><path d=\"M13 6.5h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4H2a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4zM2.5 3v5H3v-.5a1 1 0 0 1 1-1h7.5V3h-9zm2 10h9V8h-9v5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol